export default __webpack_public_path__ + "static/media/truck.84c7e82d.jpg";